import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
// import { sharedTableStyles } from '../../utils/tableStyles';
import { Skeleton } from '../../components/UI/Skeleton/Skeleton';
// import RowActionMenu from '../../components/UI/RowActionMenu/RowActionMenu';
import Select from 'react-select';
import { yupResolver } from '@hookform/resolvers/yup';
import _debounce from 'lodash/debounce';
import { Controller, useForm } from 'react-hook-form';
// import DataTable from 'react-data-table-component';
// import AdminNotes from './Notes';
import MITBanner from '../../assets/images/mit-banner.jpg';
import {
  useAddEmployeeMutation,
  // useDeleteEmployeeMutation,
  useEditEmployeeMutation,
  useGetEmployeeByIdQuery,
  useGetEmployeeQuery,
  useLazyGetEmployeeByIdQuery,
  useGetEmployeeDropDownQuery
} from '../../redux/apis/employee';
import { useUploadFileMutation } from '../../redux/apis/files';
import { useGetDesignationQuery, useGetDesignationByIdQuery } from '../../redux/apis/Designation';

// import OurClients from '../../components/Clients/OurClients';
// import { HolidaysData } from '../../components/Data/AppData';
// import PageHeader from '../../components/common/PageHeader';
// import DeleteModel from '../../components/common/DeleteModel';
// import EmptyData from '../../components/UI/EmptyData';
import SingleSelectBox from '../../components/UI/SingleSelectBox';

import { employeeSchema } from '../../utils/schemas/auth';
import { notification } from '../../utils/notification';
import {
  convertTimeStamp,
  editDateFormate,
  // paginationRow,
  skipRow,
  fullName,
  // profileImageFullName,
  withoutProfilePicture,
  // departmentOptions,
  getErrorMessage
} from '../../utils/handler';
import { BT_BUTTON_LABELS } from '../../utils/constant/buttons';
import {
  CONFIRMATION_SWITCH,
  GENDER_OPTION,
  INPUT_LABEL,
  MARITAL_STATUS_OPTION,
  PLACEHOLDER,
  SOURCE_OF_HIRE
} from '../../utils/constant/placeHolders';
import { LB_HEADER } from '../../utils/constant/labels';
import {
  EMPLOYEE_TYPE_OPTION,
  // GLOBAL,
  ROLES,
  // TABLE_ROW,
  getRecordLocality
} from '../../utils/constant/global';
import { TOAST_TYPE } from '../../utils/constant/errorMessage';
import { countryData } from '../../utils/data/countryData';

import moment from 'moment';
import { useGetDepartmentQuery, useGetDepartmentByIdQuery } from '../../redux/apis/department';
import { useGetSystemRoleQuery } from '../../redux/apis/systemRoleApi';
import { selectOfficeLocality } from '../../redux/Slice/officeSlice';
import './Members.scss';

const { BTN_SAVE, BTN_CANCEL } = BT_BUTTON_LABELS;
const {
  LB_FULL_NAME,
  LB_EMPLOYEE_CODE,
  LB_SOURCE_HR,
  LB_MOBILE,
  LB_COM_EMAIL,
  LB_DATE_OF_JOINING,
  LB_DOB,
  LB_EMERGENCY_MOBILE,
  LB_PERSONAL_EMAIL,
  LB_ADDRESS,
  LB_NATIONALITY,
  LB_GENDER_LABEL,
  LB_MARITAL_STATUS_LABEL,
  LB_EMPLOYEE_TYPE,
  LB_DESIGNATION_LABEL,
  LB_DEPARTMENT_LABEL,
  LB_REPORTING_MANAGER,
  LB_REPORTING_TL,
  LB_COMPANY_ADDRESS,
  LB_WORK,
  LB_PERSONAL_INFORMATION,
  LB_WORK_EXPERIENCE,
  LB_EDUCATION_DETAIL,
  LB_COMPANY_NAME,
  LB_JOB_TITLE,
  LB_FROM_DATE,
  LB_TO_DATE,
  LB_INSTITUTE_NAME,
  LB_DEGREE,
  LB_SPECIALIZATION,
  LB_DATE_COMPLETION,
  LB_EMPLOYEE_ROLE
} = INPUT_LABEL;
const { TOAST_SUCCESS, TOAST_ERROR } = TOAST_TYPE;
// const { ROW, DESC, ASC } = GLOBAL;
const { EMPLOYEE, MANAGEMENT, LEAD, ADMIN } = ROLES;
const { LB_ADD_EMPLOYEE_HEADER, LB_EDIT_EMPLOYEE_HEADER } = LB_HEADER;
const {
  PH_FULL_NAME,
  PH_EMPLOYEE_CODE,
  PH_MOBILE,
  // PH_SEARCH_INPUT,
  PH_NATIONALITY,
  PH_SOURCE_HIRE,
  PH_EMPLOYEE_ROLE
} = PLACEHOLDER;
/* const {
  LB_TBL_COL_EMPLOYEE_NAME,
  LB_EMPLOYEE_EMAIL,
  LB_EMPLOYEE_MOBILE,
  LB_EMPLOYEE_DESIGNATION,
  LB_EMPLOYEE_ACTION
} = LB_EMPLOYEE; */

// const { SR_EMPLOYEE_NAME, SR_EMPLOYEE_EMAIL, SR_EMPLOYEE_MOBILE } = LB_EMPLOYEE_SORT_KEYS;

const mergeEmployeesById = (...lists) => {
  const byId = new Map();
  lists.forEach((list) => {
    (Array.isArray(list) ? list : []).forEach((user) => {
      const id = user?._id || user?.id;
      if (id) byId.set(String(id), { ...user, _id: id });
    });
  });
  return Array.from(byId.values());
};

const recordLabel = (value) => {
  if (!value || typeof value !== 'object') return '';
  return value.name || value.userName || value.roleName || value.email || value.title || '';
};

const hasDisplayName = (value) => Boolean(recordLabel(value));

const unwrapRecord = (response) => {
  let current = response;
  for (let i = 0; i < 6 && current; i += 1) {
    if (Array.isArray(current)) {
      current = current[0];
      continue;
    }
    if (typeof current !== 'object') return null;
    if (current._id || current.id) return current;
    if (current.data) {
      current = current.data;
      continue;
    }
    return null;
  }
  return current?._id || current?.id ? current : null;
};

const getNamedRecordPayload = (response) => unwrapRecord(response);

const findNamedRecord = (list, selected) => {
  const id = toRecordId(selected);
  if (!id) return null;
  return (
    (Array.isArray(list) ? list : []).find(
      (item) => String(item?._id || item?.id) === String(id) && hasDisplayName(item)
    ) || null
  );
};

const getEmployeeByIdPayload = (response) => unwrapRecord(response);

const toRecordId = (value) => {
  if (!value) return '';
  if (Array.isArray(value)) return toRecordId(value[0]);
  if (typeof value === 'string') return value;
  if (typeof value === 'object') return value._id || value.id || '';
  return '';
};

const pickNamedRecord = (...candidates) => {
  for (const candidate of candidates) {
    if (Array.isArray(candidate)) {
      const named = pickNamedRecord(...candidate);
      if (named) return named;
      continue;
    }
    if (hasDisplayName(candidate)) return candidate;
  }
  return null;
};

const toEmployeeSelectOptions = (users = []) =>
  users
    .filter((val) => val?._id || val?.id)
    .map((val) => ({
      value: val._id || val.id,
      label: recordLabel(val)
    }))
    .map((opt) => ({
      ...opt,
      label: opt.label || '—'
    }));

const getSelectDefault = (record, options = []) => {
  const id = toRecordId(record);
  if (!id) return null;
  const namedLabel = recordLabel(record);
  if (namedLabel) {
    return { value: id, label: namedLabel };
  }
  return (
    (options || []).find(
      (opt) => String(opt.value) === String(id) && opt.label && opt.label !== '—'
    ) || null
  );
};

const getMultiSelectDefault = (list, options = []) =>
  asUserRecords(list)
    .map((item) => getSelectDefault(item, options))
    .filter(Boolean);

const asUserRecords = (list) => {
  if (!list) return [];
  const items = Array.isArray(list) ? list : [list];
  return items
    .map((item) => (typeof item === 'string' ? { _id: item } : item))
    .filter((item) => item && (item._id || item.id));
};

const prependSelectedRecord = (list, selected) => {
  const id = toRecordId(selected);
  if (!id) return list;
  if (list.some((item) => String(item?._id) === String(id))) return list;
  return [{ _id: id, name: recordLabel(selected) }, ...list];
};

const keepPopulated = (existing, next) => (hasDisplayName(existing) ? existing : next);

const keepPopulatedList = (existing, next) =>
  asUserRecords(existing).some(hasDisplayName) ? existing : next;

const optionToNamedRecord = (option) =>
  option?.value ? { _id: option.value, id: option.value, name: option.label } : null;

const toEmployeeFormValues = (employee, fallback) => {
  if (!employee?._id) return fallback;
  return {
    ...employee,
    department: toRecordId(employee?.department),
    designation: toRecordId(employee?.designation),
    reportingManager:
      Array.isArray(employee?.reportingManager) && employee.reportingManager.length > 0
        ? employee.reportingManager.map(toRecordId).filter(Boolean)
        : [],
    reportingTeamLead:
      Array.isArray(employee?.reportingTeamLead) && employee.reportingTeamLead.length > 0
        ? toRecordId(employee.reportingTeamLead[0])
        : toRecordId(employee?.reportingTeamLead) || null,
    employmentType: employee?.employmentType,
    companyAddress: employee?.companyAddress,
    allowWorkFromHome: employee?.allowWorkFromHome || false,
    isActive: employee?.isActive !== false,
    isConfirmationDone: employee?.isConfirmationDone || false,
    hrxRoleData: toRecordId(employee?.hrxRole)
  };
};

const looksLikeMongoId = (value) => typeof value === 'string' && /^[a-fA-F0-9]{24}$/.test(value);

const displayName = (value) => {
  if (!value) return '';
  if (typeof value === 'object') return value.name || value.userName || '';
  if (looksLikeMongoId(value)) return '';
  return value;
};

const getExperienceDisplayRows = (employee) => {
  if (Array.isArray(employee?.workExperience) && employee.workExperience.length) {
    return employee.workExperience.map((item) => ({
      company: item?.companyName || '-',
      title: item?.jobTitle || item?.title || '-',
      start: item?.fromDate || item?.start,
      end: item?.toDate === 0 || item?.end === 0 ? 0 : (item?.toDate ?? item?.end)
    }));
  }
  if (Array.isArray(employee?.experience) && employee.experience.length) {
    return employee.experience.map((item) => ({
      company: displayName(item?.companyName) || '-',
      title: item?.title || item?.jobTitle || '-',
      start: item?.start || item?.fromDate,
      end: item?.end === 0 || item?.toDate === 0 ? 0 : (item?.end ?? item?.toDate)
    }));
  }
  return [];
};

const getEducationDisplayRows = (employee) => {
  if (Array.isArray(employee?.educationDetails) && employee.educationDetails.length) {
    return employee.educationDetails.map((item) => ({
      institute: item?.instituteName || '-',
      degree: item?.degree || '-',
      specialization: item?.specialization || '-',
      year: item?.dateofCompletion || '-'
    }));
  }
  if (Array.isArray(employee?.education) && employee.education.length) {
    return employee.education.map((item) => ({
      institute: displayName(item?.eduInfo?.institute) || '-',
      degree: displayName(item?.eduInfo?.degree) || '-',
      specialization: displayName(item?.eduInfo?.fieldOfStudy) || '-',
      year: item?.eduInfo?.end ? new Date(parseInt(item.eduInfo.end, 10)).getFullYear() : '-'
    }));
  }
  return [];
};

const DROPDOWN_PAGE_SIZE = 50;
const EMPLOYEE_FORM_TABS = ['personal', 'work', 'experience', 'education'];
const EMPLOYEE_LIST_PATH = '/employees';
const EMPTY_LIST = [];
const SKELETON_FIELD_WIDTHS = [72, 88, 64, 96, 80, 70, 90, 76, 84, 68, 92, 74, 78, 86];

const EmployeeFormSkeleton = ({ tab = 'personal', onBack }) => {
  const isTableTab = tab === 'experience' || tab === 'education';
  const fieldCount = tab === 'work' ? 5 : 14;

  return (
    <div className="employee-form container-xxl">
      <div
        className="employee-form__card employee-form__card--loading"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <span className="visually-hidden">Loading employee details</span>
        <span className="employee-form__progress" aria-hidden />

        <div className="employee-form__cover">
          <div className="employee-form__cover-media">
            <img className="employee-form__cover-img" src={MITBanner} alt="" />
            <span className="employee-form__cover-shade" aria-hidden />
          </div>
          <button type="button" className="employee-form__back" aria-label="Back" onClick={onBack}>
            <i className="icofont-rounded-left" aria-hidden />
          </button>
          <div className="employee-form__profile employee-form__skeleton-profile">
            <Skeleton
              variant="circle"
              width={96}
              height={96}
              className="employee-form__skeleton-avatar"
            />
            <div className="employee-form__skeleton-identity">
              <Skeleton width={168} height={22} className="employee-form__skeleton-on-cover" />
              <Skeleton width={220} height={12} className="employee-form__skeleton-on-cover" />
              <div className="employee-form__skeleton-chips">
                <Skeleton
                  width={88}
                  height={22}
                  className="employee-form__skeleton-on-cover"
                  style={{ borderRadius: 999 }}
                />
                <Skeleton
                  width={72}
                  height={22}
                  className="employee-form__skeleton-on-cover"
                  style={{ borderRadius: 999 }}
                />
              </div>
            </div>
          </div>
        </div>

        <nav className="employee-form__tabs" aria-hidden>
          <div className="employee-form__tabs-list employee-form__skeleton-tabs">
            {[
              { id: 'personal', width: 112 },
              { id: 'work', width: 128 },
              { id: 'experience', width: 118 },
              { id: 'education', width: 108 }
            ].map((item) => (
              <span
                className={`employee-form__skeleton-tab${tab === item.id ? ' is-active' : ''}`}
                key={item.id}
              >
                <Skeleton width={18} height={18} style={{ borderRadius: 6 }} />
                <Skeleton width={item.width} height={12} />
              </span>
            ))}
          </div>
          <div className="employee-form__switches">
            {[0, 1].map((key) => (
              <div className="employee-form__skeleton-wfh" key={key}>
                <div className="employee-form__skeleton-wfh-copy">
                  <Skeleton width={key === 0 ? 108 : 96} height={10} />
                  <Skeleton width={72} height={8} />
                </div>
                <Skeleton width={42} height={22} style={{ borderRadius: 999 }} />
              </div>
            ))}
          </div>
        </nav>

        <div className="employee-form__main">
          <div className="employee-form__group">
            <div className="employee-form__skeleton-heading">
              <Skeleton width={4} height={14} style={{ borderRadius: 999 }} />
              <Skeleton width={tab === 'work' ? 140 : 128} height={14} />
            </div>

            {isTableTab ? (
              <div className="employee-form__skeleton-table">
                <div className="employee-form__skeleton-table-head">
                  {Array.from({ length: 4 }).map((_, i) => (
                    <Skeleton key={i} width={`${48 + (i % 3) * 10}%`} height={10} />
                  ))}
                </div>
                {Array.from({ length: 4 }).map((_, row) => (
                  <div className="employee-form__skeleton-table-row" key={row}>
                    {Array.from({ length: 4 }).map((_, col) => (
                      <Skeleton key={col} width={`${52 + ((row + col) % 3) * 14}%`} height={12} />
                    ))}
                  </div>
                ))}
              </div>
            ) : (
              <div className="employee-form__skeleton-grid">
                {SKELETON_FIELD_WIDTHS.slice(0, fieldCount).map((width, i) => (
                  <div className="employee-form__skeleton-field" key={i}>
                    <Skeleton width={width} height={10} />
                    <Skeleton height={42} style={{ borderRadius: 10 }} />
                  </div>
                ))}
                <div className="employee-form__skeleton-field employee-form__skeleton-field--wide">
                  <Skeleton width={tab === 'work' ? 118 : 86} height={10} />
                  <Skeleton height={tab === 'work' ? 42 : 76} style={{ borderRadius: 10 }} />
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="employee-form__footer">
          <button type="button" className="employee-form__cancel" onClick={onBack}>
            {BTN_CANCEL}
          </button>
          <button type="button" className="employee-form__save" disabled>
            {BTN_SAVE}
          </button>
        </div>
      </div>
    </div>
  );
};

const getEmployeeIdFromPath = (pathname = '') => {
  const match = String(pathname).match(/^\/employees\/([^/]+)\/?$/);
  const id = match?.[1];
  if (!id || id === 'undefined' || id === 'null') return undefined;
  return id;
};

const initialState = {
  employeeList: [],
  isModal: false,
  search: '',
  isEditModalData: {},
  isDelete: { id: '', status: '' },
  grid: false,
  currentPage: 1,
  rowsPerPage: 10,
  currentPageDropdown: 1,
  rowsPerPageDropdown: 50,
  isNext: false,
  sortField: 'name',
  sortDirection: true,
  loading: false,
  yearsOption: [],
  designationSelect: '',
  reportingManagerSelect: '',
  departmentSelect: '',
  dropdownDataStore: [],
  reportingTeamLeadList: [],
  designationDropdownPage: 1,
  designationDropdownStore: [],
  designationDropdownSearch: '',
  designationDropdownSearchStore: [],
  designationDropdownIsNext: false,
  departmentDropdownPage: 1,
  departmentDropdownStore: [],
  departmentDropdownSearch: '',
  departmentDropdownSearchStore: [],
  departmentDropdownIsNext: false,
  drawerOpen: false,
  selectedRowUserId: null,
  noteDrawer: false,
  rowLoading: {}
};

function EmployeeDetails() {
  const officeLocality = useSelector(selectOfficeLocality);
  const isAuOffice = officeLocality.includes('AU');
  const navigate = useNavigate();
  const location = useLocation();
  const { id: paramEmployeeId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const routeEmployeeId = paramEmployeeId || getEmployeeIdFromPath(location.pathname);
  const showEmployeeForm = Boolean(routeEmployeeId);
  const [state, setState] = useState(() => {
    const seeded =
      location.state?.employee?._id === routeEmployeeId ? location.state.employee : null;
    return {
      ...initialState,
      isModal: Boolean(routeEmployeeId),
      isEditModalData: seeded || (routeEmployeeId ? { _id: routeEmployeeId } : {})
    };
  });
  const tabFromQuery = searchParams.get('tab') || searchParams.get('tabactive');
  const formTab = EMPLOYEE_FORM_TABS.includes(tabFromQuery) ? tabFromQuery : 'personal';
  const setFormTab = (tab) => {
    if (!EMPLOYEE_FORM_TABS.includes(tab) || !routeEmployeeId) return;
    setSearchParams({ tab }, { replace: true });
  };

  /*  const openEmployeeForm = (employee, tab = 'personal') => {
    if (!employee?._id) return;
    navigate(`${EMPLOYEE_LIST_PATH}/${employee._id}?tab=${tab}`, {
      state: { employee }
    });
  }; */

  const closeEmployeeForm = ({ replace = false } = {}) => {
    navigate(EMPLOYEE_LIST_PATH, { replace });
  };
  /*  const employeeTableStyles = {
    table: {
      style: {
        backgroundColor: 'transparent'
      }
    },
    headRow: {
      style: {
        backgroundColor: '#f8fafc',
        borderBottom: '1px solid #e6edf5',
        minHeight: '44px'
      }
    },
    headCells: {
      style: {
        fontWeight: 700,
        fontSize: '12px',
        color: '#334155',
        textTransform: 'uppercase',
        letterSpacing: '0.3px',
        whiteSpace: 'nowrap',
        paddingLeft: '14px',
        paddingRight: '14px'
      }
    },
    rows: {
      style: {
        minHeight: '52px',
        borderBottom: '1px solid #eef2f7',
        backgroundColor: '#ffffff'
      },
      highlightOnHoverStyle: {
        backgroundColor: '#f5f8ff',
        borderBottomColor: '#e6edf5',
        outline: 'none'
      }
    },
    cells: {
      style: {
        color: '#1f2937',
        fontWeight: 600,
        fontSize: '13px',
        paddingLeft: '14px',
        paddingRight: '14px'
      }
    },
    pagination: {
      style: {
        borderTop: '1px solid #eef2f7',
        paddingTop: '10px',
        paddingBottom: '10px'
      }
    }
  }; */
  const {
    data: designationDropdownResponse,
    isFetching: designationDropdownFetching,
    refetch: refetchDesignationDropdown
  } = useGetDesignationQuery({
    search: state.designationDropdownSearch,
    skip: skipRow(state.designationDropdownPage, DROPDOWN_PAGE_SIZE),
    limit: DROPDOWN_PAGE_SIZE
  });

  const {
    data: departmentDropdownResponse,
    isFetching: departmentDropdownFetching,
    refetch: refetchDepartmentDropdown
  } = useGetDepartmentQuery({
    search: state.departmentDropdownSearch,
    skip: skipRow(state.departmentDropdownPage, DROPDOWN_PAGE_SIZE),
    limit: DROPDOWN_PAGE_SIZE
  });

  const editEmployeeId = routeEmployeeId || undefined;
  const {
    data: employeeByIdResponse,
    isLoading: isEmployeeDetailLoading,
    isFetching: isEmployeeDetailFetching,
    isError: isEmployeeDetailError,
    isUninitialized: isEmployeeDetailUninitialized,
    refetch: refetchEmployeeById
  } = useGetEmployeeByIdQuery(editEmployeeId, {
    skip: !editEmployeeId,
    refetchOnMountOrArgChange: true
  });
  const employeeDetail = getEmployeeByIdPayload(employeeByIdResponse);
  const hydrateSearchTerm =
    employeeDetail?.email ||
    employeeDetail?.personalEmail ||
    state.isEditModalData?.email ||
    state.isEditModalData?.personalEmail ||
    employeeDetail?.name ||
    '';

  const { data: employeeListMatchResponse } = useGetEmployeeQuery(
    {
      search: hydrateSearchTerm,
      limit: 20,
      hrxRole: EMPLOYEE
    },
    { skip: !editEmployeeId || !hydrateSearchTerm }
  );

  const listEmployee = useMemo(() => {
    const payload = employeeListMatchResponse?.data ?? employeeListMatchResponse;
    const rows = Array.isArray(payload) ? payload : payload?.data;
    if (!Array.isArray(rows) || !editEmployeeId) return null;
    return rows.find((row) => String(row?._id) === String(editEmployeeId)) || null;
  }, [employeeListMatchResponse, editEmployeeId]);

  const { data: designationCatalogResponse } = useGetDesignationQuery(
    { skip: 0, limit: 500 },
    { skip: !editEmployeeId }
  );
  const { data: departmentCatalogResponse } = useGetDepartmentQuery(
    { skip: 0, limit: 500 },
    { skip: !editEmployeeId }
  );
  const designationCatalog = useMemo(
    () =>
      Array.isArray(designationCatalogResponse?.data)
        ? designationCatalogResponse.data
        : EMPTY_LIST,
    [designationCatalogResponse?.data]
  );
  const departmentCatalog = useMemo(
    () =>
      Array.isArray(departmentCatalogResponse?.data) ? departmentCatalogResponse.data : EMPTY_LIST,
    [departmentCatalogResponse?.data]
  );

  const selectedDesignationId =
    toRecordId(state.isEditModalData?.designation) ||
    toRecordId(listEmployee?.designation) ||
    toRecordId(employeeDetail?.designation);
  const selectedDepartmentId =
    toRecordId(state.isEditModalData?.department) ||
    toRecordId(listEmployee?.department) ||
    toRecordId(employeeDetail?.department);
  const selectedTeamLeadId =
    toRecordId(state.isEditModalData?.reportingTeamLead) ||
    toRecordId(listEmployee?.reportingTeamLead) ||
    toRecordId(employeeDetail?.reportingTeamLead);

  const { data: designationByIdResponse } = useGetDesignationByIdQuery(selectedDesignationId, {
    skip: !selectedDesignationId || hasDisplayName(state.isEditModalData?.designation)
  });
  const { data: departmentByIdResponse } = useGetDepartmentByIdQuery(selectedDepartmentId, {
    skip: !selectedDepartmentId || hasDisplayName(state.isEditModalData?.department)
  });
  const { data: teamLeadByIdResponse } = useGetEmployeeByIdQuery(selectedTeamLeadId, {
    skip:
      !selectedTeamLeadId ||
      String(selectedTeamLeadId) === String(editEmployeeId) ||
      hasDisplayName(asUserRecords(state.isEditModalData?.reportingTeamLead)[0])
  });
  const designationById = getNamedRecordPayload(designationByIdResponse);
  const departmentById = getNamedRecordPayload(departmentByIdResponse);
  const teamLeadById =
    getEmployeeByIdPayload(teamLeadByIdResponse) || getNamedRecordPayload(teamLeadByIdResponse);

  const {
    data: dropdownData,
    isLoading: dropdownDataLoading,
    isFetching: dropdownDataIsFetching,
    refetch: employeeDropDownQuery
  } = useGetEmployeeDropDownQuery(
    { limit: 100, hrxRole: MANAGEMENT },
    { refetchOnMountOrArgChange: true }
  );
  const {
    data: teamLead,
    isLoading: teamLeadLoading,
    isFetching: teamLeadDataIsFetching,
    refetch: teamLeadDropDownQuery
  } = useGetEmployeeDropDownQuery(
    { limit: 100, hrxRole: LEAD },
    { refetchOnMountOrArgChange: true }
  );
  const { data: adminDropdown, refetch: adminDropDownQuery } = useGetEmployeeDropDownQuery(
    { limit: 100, hrxRole: ADMIN },
    { skip: !isAuOffice, refetchOnMountOrArgChange: true }
  );

  const [fetchUserById] = useLazyGetEmployeeByIdQuery();
  const [namedUsersById, setNamedUsersById] = useState({});
  const fetchedUserIdsRef = useRef(new Set());

  useEffect(() => {
    const managerIds = asUserRecords(
      state.isEditModalData?.reportingManager ||
        listEmployee?.reportingManager ||
        employeeDetail?.reportingManager
    )
      .map(toRecordId)
      .filter(Boolean);

    managerIds.forEach((id) => {
      const key = String(id);
      if (fetchedUserIdsRef.current.has(key)) return;
      if (
        findNamedRecord(
          mergeEmployeesById(
            asUserRecords(listEmployee?.reportingManager),
            dropdownData?.data,
            adminDropdown?.data
          ),
          id
        )
      ) {
        return;
      }
      fetchedUserIdsRef.current.add(key);
      fetchUserById(id)
        .unwrap()
        .then((response) => {
          const user = getEmployeeByIdPayload(response) || getNamedRecordPayload(response);
          if (user?._id) {
            setNamedUsersById((prev) => ({ ...prev, [String(user._id)]: user }));
          }
        })
        .catch(() => {});
    });
  }, [
    adminDropdown?.data,
    dropdownData?.data,
    employeeDetail?.reportingManager,
    fetchUserById,
    listEmployee?.reportingManager,
    state.isEditModalData?.reportingManager
  ]);

  const projectManagerOptions = useMemo(
    () =>
      toEmployeeSelectOptions(
        mergeEmployeesById(
          asUserRecords(state.isEditModalData?.reportingManager),
          asUserRecords(listEmployee?.reportingManager),
          Object.values(namedUsersById),
          dropdownData?.data,
          isAuOffice ? adminDropdown?.data : []
        )
      ),
    [
      dropdownData?.data,
      adminDropdown?.data,
      isAuOffice,
      namedUsersById,
      listEmployee?.reportingManager,
      state.isEditModalData?.reportingManager
    ]
  );

  const teamLeadOptions = useMemo(
    () =>
      toEmployeeSelectOptions(
        mergeEmployeesById(
          asUserRecords(state.isEditModalData?.reportingTeamLead),
          asUserRecords(listEmployee?.reportingTeamLead),
          teamLeadById ? [teamLeadById] : [],
          teamLead?.data,
          isAuOffice ? adminDropdown?.data : []
        )
      ),
    [
      teamLead?.data,
      adminDropdown?.data,
      isAuOffice,
      teamLeadById,
      listEmployee?.reportingTeamLead,
      state.isEditModalData?.reportingTeamLead
    ]
  );

  const designationOptions = useMemo(() => {
    const hasSearch = Boolean(state.designationDropdownSearch?.trim());
    let list = hasSearch ? state.designationDropdownSearchStore : state.designationDropdownStore;
    list = prependSelectedRecord(
      list,
      pickNamedRecord(
        state.isEditModalData?.designation,
        listEmployee?.designation,
        employeeDetail?.designation,
        designationById,
        findNamedRecord(designationCatalog, selectedDesignationId)
      ) || state.isEditModalData?.designation
    );
    return toEmployeeSelectOptions(list);
  }, [
    state.designationDropdownSearch,
    state.designationDropdownSearchStore,
    state.designationDropdownStore,
    state.isEditModalData?.designation,
    listEmployee?.designation,
    employeeDetail?.designation,
    designationById,
    designationCatalog,
    selectedDesignationId
  ]);

  const departmentOptions = useMemo(() => {
    const hasSearch = Boolean(state.departmentDropdownSearch?.trim());
    let list = hasSearch ? state.departmentDropdownSearchStore : state.departmentDropdownStore;
    list = prependSelectedRecord(
      list,
      pickNamedRecord(
        state.isEditModalData?.department,
        listEmployee?.department,
        employeeDetail?.department,
        departmentById,
        findNamedRecord(departmentCatalog, selectedDepartmentId)
      ) || state.isEditModalData?.department
    );
    return toEmployeeSelectOptions(list);
  }, [
    state.departmentDropdownSearch,
    state.departmentDropdownSearchStore,
    state.departmentDropdownStore,
    state.isEditModalData?.department,
    listEmployee?.department,
    employeeDetail?.department,
    departmentById,
    departmentCatalog,
    selectedDepartmentId
  ]);

  const designationUsesServerSearch = Boolean(state.designationDropdownSearch?.trim());
  const departmentUsesServerSearch = Boolean(state.departmentDropdownSearch?.trim());

  const debouncedDesignationSearch = useMemo(
    () =>
      _debounce((text) => {
        const term = String(text || '').trim();
        setState((prev) => ({
          ...prev,
          designationDropdownSearch: term,
          designationDropdownPage: 1,
          ...(term ? { designationDropdownSearchStore: [] } : {})
        }));
      }, 300),
    []
  );

  const debouncedDepartmentSearch = useMemo(
    () =>
      _debounce((text) => {
        const term = String(text || '').trim();
        setState((prev) => ({
          ...prev,
          departmentDropdownSearch: term,
          departmentDropdownPage: 1,
          ...(term ? { departmentDropdownSearchStore: [] } : {})
        }));
      }, 300),
    []
  );

  const debouncedDesignationSearchRef = useRef(debouncedDesignationSearch);
  const debouncedDepartmentSearchRef = useRef(debouncedDepartmentSearch);
  debouncedDesignationSearchRef.current = debouncedDesignationSearch;
  debouncedDepartmentSearchRef.current = debouncedDepartmentSearch;

  useEffect(
    () => () => {
      debouncedDesignationSearchRef.current.cancel();
      debouncedDepartmentSearchRef.current.cancel();
    },
    []
  );

  const [addEmployee] = useAddEmployeeMutation();
  const [editEmployee] = useEditEmployeeMutation();
  // const [deleteEmployee] = useDeleteEmployeeMutation();
  const [uploadFile] = useUploadFileMutation();
  const profilePicInputRef = useRef(null);
  const [profilePicUploading, setProfilePicUploading] = useState(false);
  const { data: roleList, refetch: refetchSystemRoles } = useGetSystemRoleQuery();

  const roleOptions = roleList?.data?.map((role) => ({
    value: role._id,
    label: role.roleName
  }));

  /*   const handleChangeSort = (sortField) => {
      setState({ ...state, sortDirection: !state.sortDirection, sortField: sortField.sortField });
    }; */

  useEffect(() => {
    try {
      refetchDesignationDropdown();
      refetchDepartmentDropdown();
      refetchSystemRoles();
    } catch (error) {
      notification(error.message, TOAST_ERROR);
    }
  }, []);

  useEffect(() => {
    const rows = designationDropdownResponse?.data;
    if (!Array.isArray(rows)) return;

    setState((prev) => {
      const isSearchActive = Boolean(prev.designationDropdownSearch?.trim());

      if (isSearchActive) {
        const merged =
          prev.designationDropdownPage === 1
            ? rows
            : mergeEmployeesById(prev.designationDropdownSearchStore, rows);
        return {
          ...prev,
          designationDropdownSearchStore: merged,
          designationDropdownIsNext: Boolean(designationDropdownResponse?.isNext)
        };
      }

      const shouldSeed =
        prev.designationDropdownPage === 1 && prev.designationDropdownStore.length === 0;
      const merged = shouldSeed
        ? rows
        : prev.designationDropdownPage === 1
          ? prev.designationDropdownStore
          : mergeEmployeesById(prev.designationDropdownStore, rows);

      return {
        ...prev,
        designationDropdownStore: merged,
        designationDropdownIsNext: Boolean(designationDropdownResponse?.isNext)
      };
    });
  }, [designationDropdownResponse]);

  useEffect(() => {
    const rows = departmentDropdownResponse?.data;
    if (!Array.isArray(rows)) return;

    setState((prev) => {
      const isSearchActive = Boolean(prev.departmentDropdownSearch?.trim());

      if (isSearchActive) {
        const merged =
          prev.departmentDropdownPage === 1
            ? rows
            : mergeEmployeesById(prev.departmentDropdownSearchStore, rows);
        return {
          ...prev,
          departmentDropdownSearchStore: merged,
          departmentDropdownIsNext: Boolean(departmentDropdownResponse?.isNext)
        };
      }

      const shouldSeed =
        prev.departmentDropdownPage === 1 && prev.departmentDropdownStore.length === 0;
      const merged = shouldSeed
        ? rows
        : prev.departmentDropdownPage === 1
          ? prev.departmentDropdownStore
          : mergeEmployeesById(prev.departmentDropdownStore, rows);

      return {
        ...prev,
        departmentDropdownStore: merged,
        departmentDropdownIsNext: Boolean(departmentDropdownResponse?.isNext)
      };
    });
  }, [departmentDropdownResponse]);

  const defaultValue = {
    name: '',
    zohoEmployeeId: '',
    lastName: '',
    email: '',
    phone: '',
    dateOfJoining: null,
    dateOfBirth: null,
    sourceOfHire: '',
    emergencyMobile: '',
    personalEmail: '',
    location: '',
    gender: '',
    nationality: '',
    maritalStatus: '',
    employmentType: '',
    department: '',
    designation: '',
    reportingManager: [],
    workExperience: [],
    educationDetails: [],
    allowWorkFromHome: false,
    isActive: true,
    isConfirmationDone: false,
    reportingTeamLead: '',
    hrxRole: ''
  };
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    control,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(employeeSchema),
    defaultValues: defaultValue
  });
  const valuesData = watch();
  const [formReadyId, setFormReadyId] = useState('');

  useEffect(() => {
    reset(toEmployeeFormValues(state.isEditModalData, defaultValue));
    const detailId = state.isEditModalData?._detailId;
    if (detailId) setFormReadyId(String(detailId));
  }, [
    reset,
    state.isEditModalData?._id,
    state.isEditModalData?._detailId,
    state.isEditModalData?._detailUpdatedAt
  ]);

  const designationSelectValue =
    getSelectDefault(valuesData.designation, designationOptions) ||
    getSelectDefault(
      pickNamedRecord(
        state.isEditModalData?.designation,
        listEmployee?.designation,
        employeeDetail?.designation,
        designationById,
        findNamedRecord(state.designationDropdownStore, selectedDesignationId),
        findNamedRecord(designationCatalog, selectedDesignationId)
      ) || selectedDesignationId,
      designationOptions
    );
  const departmentSelectValue =
    getSelectDefault(valuesData.department, departmentOptions) ||
    getSelectDefault(
      pickNamedRecord(
        state.isEditModalData?.department,
        listEmployee?.department,
        employeeDetail?.department,
        departmentById,
        findNamedRecord(state.departmentDropdownStore, selectedDepartmentId),
        findNamedRecord(departmentCatalog, selectedDepartmentId)
      ) || selectedDepartmentId,
      departmentOptions
    );
  const reportingManagerSelectValue = getMultiSelectDefault(
    (Array.isArray(valuesData.reportingManager) && valuesData.reportingManager.length
      ? valuesData.reportingManager
      : asUserRecords(
          state.isEditModalData?.reportingManager ||
            listEmployee?.reportingManager ||
            employeeDetail?.reportingManager
        )
    ).map((item) => {
      const id = toRecordId(item);
      return (
        pickNamedRecord(
          item,
          findNamedRecord(asUserRecords(listEmployee?.reportingManager), id),
          namedUsersById[String(id)],
          findNamedRecord(mergeEmployeesById(dropdownData?.data, adminDropdown?.data), id)
        ) || item
      );
    }),
    projectManagerOptions
  );
  const reportingTeamLeadSelectValue =
    getSelectDefault(valuesData.reportingTeamLead, teamLeadOptions) ||
    getSelectDefault(
      pickNamedRecord(
        state.isEditModalData?.reportingTeamLead,
        listEmployee?.reportingTeamLead,
        employeeDetail?.reportingTeamLead,
        teamLeadById,
        findNamedRecord(mergeEmployeesById(teamLead?.data, adminDropdown?.data), selectedTeamLeadId)
      ) || selectedTeamLeadId,
      teamLeadOptions
    );

  const patchEmployeeSelectField = (field, selected) => {
    const record = Array.isArray(selected)
      ? selected.map(optionToNamedRecord).filter(Boolean)
      : optionToNamedRecord(selected);
    setState((prev) => ({
      ...prev,
      isEditModalData: {
        ...prev.isEditModalData,
        [field]: record
      }
    }));
  };
  const editEmployeeData = async (data) => {
    try {
      setState({ ...state, loading: true });

      const res = await editEmployee({ data: data, id: state?.isEditModalData?._id });
      if (res.data?.success) {
        notification(res?.data?.statusMessage, TOAST_SUCCESS);
        closeEmployeeForm({ replace: true });
      } else {
        reset();
        setState((prev) => ({ ...prev, loading: false }));
        notification(res?.data?.statusMessage, TOAST_ERROR);
      }
    } catch (error) {
      notification(error.message, TOAST_ERROR);
    }
  };

  const addEmployeeData = async (data) => {
    try {
      setState({ ...state, loading: true });
      const employeeData = {
        ...data,
        role: EMPLOYEE
      };
      const res = await addEmployee(employeeData);
      if (res.data?.success) {
        notification(res?.data?.statusMessage, TOAST_SUCCESS);
        closeEmployeeForm({ replace: true });
      } else {
        reset();
        setState((prev) => ({ ...prev, loading: false }));
        notification(res?.data?.statusMessage, TOAST_ERROR);
      }
    } catch (error) {
      notification(error.message, TOAST_ERROR);
    }
  };

  const handleProfilePicChange = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      notification('Please select an image file', TOAST_ERROR);
      return;
    }

    const previewUrl = URL.createObjectURL(file);
    setState((prev) => ({
      ...prev,
      isEditModalData: {
        ...prev.isEditModalData,
        profilePicture: previewUrl
      }
    }));

    try {
      setProfilePicUploading(true);
      const formData = new FormData();
      formData.append('files', file);
      const response = await uploadFile(formData);

      if (!response?.data?.success) {
        notification(
          response?.data?.message || response?.error?.data?.statusMessage || 'Upload failed',
          TOAST_ERROR
        );
        return;
      }

      const uploadedUrl = response.data.data?.files?.[0]?.location;
      if (!uploadedUrl) {
        notification('Upload failed', TOAST_ERROR);
        return;
      }

      setState((prev) => ({
        ...prev,
        isEditModalData: {
          ...prev.isEditModalData,
          profilePicture: uploadedUrl
        }
      }));

      if (state.isEditModalData?._id) {
        const locality = getRecordLocality(state.isEditModalData);
        const res = await editEmployee({
          data: {
            profilePicture: uploadedUrl,
            ...(locality.length ? { locality } : {})
          },
          id: state.isEditModalData._id
        });

        if (res?.data?.success) {
          notification(res.data.statusMessage, TOAST_SUCCESS);
          refetchEmployeeById();
        } else {
          notification(
            res?.error?.data?.statusMessage ||
              res?.data?.statusMessage ||
              'Could not save profile picture',
            TOAST_ERROR
          );
        }
      }
    } catch (error) {
      notification(error?.message || 'Something went wrong', TOAST_ERROR);
    } finally {
      setProfilePicUploading(false);
    }
  };

  const onSubmit = (data) => {
    try {
      const employeeData = {
        userName: fullName(data),
        name: data.name,
        lastName: data.lastName,
        zohoEmployeeId: data.zohoEmployeeId?.trim?.() || data.zohoEmployeeId,
        email: data.email,
        phone: data.phone,
        dateOfJoining: data.dateOfJoining,
        dateOfBirth: data.dateOfBirth,
        gender: data.gender,
        maritalStatus: data.maritalStatus,
        nationality: data.nationality,
        emergencyMobile: data.emergencyMobile,
        personalEmail: data.personalEmail,
        location: data.location,
        sourceOfHire: data.sourceOfHire,
        employmentType: data.employmentType,
        companyAddress: data.companyAddress,
        hrxRole: valuesData?.hrxRoleData,
        reportingTeamLead: [valuesData.reportingTeamLead],
        reportingManager: valuesData.reportingManager,
        educationDetails: data.educationDetails,
        workExperience: data.workExperience,
        department: data.department,
        allowWorkFromHome: data.allowWorkFromHome,
        isActive: data.isActive !== false,
        designation: data.designation,
        locality:
          Array.isArray(data.locality) && data.locality.length
            ? data.locality
            : getRecordLocality(state.isEditModalData),
        isConfirmationDone:
          data?.isConfirmationDone === 'true' || data?.isConfirmationDone === true ? true : false,
        ...(typeof state.isEditModalData?.profilePicture === 'string' &&
        state.isEditModalData.profilePicture.startsWith('http')
          ? { profilePicture: state.isEditModalData.profilePicture }
          : {})
      };

      if (state.isEditModalData._id) {
        editEmployeeData(employeeData);
      } else {
        addEmployeeData(employeeData);
      }
    } catch (error) {
      notification(getErrorMessage(error), TOAST_ERROR);
    }
  };

  /*  const WFHSwitch = ({ value, onChange, loading }) => (
    <div
      className="employee-wfh-switch form-check form-switch theme-switch"
      style={{ position: 'relative', width: 32, height: 16, minHeight: 16, margin: 0, padding: 0 }}
    >
      <input
        className="form-check-input"
        type="checkbox"
        checked={value}
        disabled={loading}
        onChange={(e) => onChange(e.target.checked)}
        style={{
          width: 32,
          height: 16,
          margin: 0,
          float: 'none',
          borderRadius: 30,
          backgroundColor: value ? '#484c7f' : '#ddd',
          backgroundSize: '12px 12px',
          transition: 'background-color 0.3s',
          cursor: loading ? 'not-allowed' : 'pointer',
          position: 'relative',
          zIndex: 1
        }}
      />
      {loading ? (
        <span className="employee-wfh-switch__loader" role="status" aria-label="Saving">
          <span className="spinner-border" />
        </span>
      ) : null}
    </div>
  ); */

  /* const handleWFHToggle = async (row, value) => {
    const nextValue = typeof value === 'boolean' ? value : !row.allowWorkFromHome;

    setState((prev) => ({
      ...prev,
      rowLoading: { ...prev.rowLoading, [row?._id]: true }
    }));

    try {
      const res = await editEmployee({
        id: row._id,
        data: {
          allowWorkFromHome: nextValue,
          locality: getRecordLocality(row)
        }
      });

      if (res?.data?.success) {
        setState((prev) => ({
          ...prev,
          rowLoading: { ...prev.rowLoading, [row?._id]: false },
          employeeList: prev.employeeList.map((item) =>
            item._id === row._id ? { ...item, allowWorkFromHome: nextValue } : item
          )
        }));
        return;
      }

      setState((prev) => ({
        ...prev,
        rowLoading: { ...prev.rowLoading, [row?._id]: false }
      }));
      notification(
        res?.error?.data?.statusMessage ||
          res?.error?.message ||
          res?.data?.statusMessage ||
          'Failed to update work from home.',
        TOAST_ERROR
      );
    } catch (error) {
      setState((prev) => ({
        ...prev,
        rowLoading: { ...prev.rowLoading, [row?._id]: false }
      }));
      notification(error?.message || 'Failed to update work from home.', TOAST_ERROR);
    }
  }; */

  /* const onDeleteUser = async (id) => {
    try {
      const res = await deleteEmployee(id);
      if (res.data?.success) {
        setState({ ...state, isDelete: { id: '', status: false } });
        notification(res?.data?.statusMessage, TOAST_SUCCESS);
      } else {
        reset();
        notification(res?.data?.statusMessage, TOAST_ERROR);
      }
    } catch (error) {
      notification(error.message, TOAST_ERROR);
    }
  }; */

  // var columnsT = '';

  /* columnsT = [
    {
      name: LB_TBL_COL_EMPLOYEE_NAME,
      sortField: SR_EMPLOYEE_NAME,
      cell: (row) => profileImageFullName(row),
      sortable: true,
      minWidth: '320px',
      grow: 2,
      wrap: true
    },
    {
      name: LB_EMPLOYEE_EMAIL,
      sortField: SR_EMPLOYEE_EMAIL,
      selector: (row) => <span className={row.txtClass}>{row.email || ''}</span>,
      sortable: true
    },
    {
      name: LB_EMPLOYEE_MOBILE,
      sortField: SR_EMPLOYEE_MOBILE,
      selector: (row) => <span className={row.txtClass}>{row.phone || ''}</span>,
      sortable: false
    },
    {
      name: LB_EMPLOYEE_DESIGNATION,
      selector: (row) => <span className={row.txtClass}>{row?.designation?.name || '-'}</span>,
      sortable: false
    },
    {
      name: 'WFH',
      sortable: false,
      width: '120px',
      center: true,
      cell: (row) => (
        <WFHSwitch
          value={row.allowWorkFromHome}
          loading={!!state.rowLoading[row._id]}
          onChange={(value) => handleWFHToggle(row, value)}
        />
      )
    },

    {
      name: LB_EMPLOYEE_ACTION,
      selector: () => {},
      sortable: false,
      cell: (row) => (
        <RowActionMenu
          actions={[
            {
              label: 'Edit',
              icon: 'icofont-edit',
              variant: 'success',
              onClick: () => openEmployeeForm(row)
            },
            {
              label: 'Files',
              icon: 'icofont-document-folder',
              hidden: isAuOffice,
              onClick: () => navigate(`/employees/${row._id}/files`)
            },
            {
              label: 'Note',
              icon: 'icofont-ui-note',
              onClick: () => setState({ ...state, noteDrawer: true, selectedRowUserId: row._id })
            }
          ]}
        />
      )
    }
  ]; */

  useEffect(() => {
    if (!routeEmployeeId) {
      setState((prev) => {
        if (!prev.isModal && !prev.isEditModalData?._id) return prev;
        return {
          ...prev,
          isModal: false,
          isEditModalData: {},
          reportingManagerSelect: '',
          loading: false
        };
      });
      return;
    }

    const seeded =
      location.state?.employee?._id === routeEmployeeId ? location.state.employee : null;

    setState((prev) => {
      const current = prev.isEditModalData?._id === routeEmployeeId ? prev.isEditModalData : {};
      const currentIsStub = !current.name && !current.email;
      const base =
        currentIsStub && seeded
          ? { ...seeded, ...current, _id: routeEmployeeId }
          : { ...current, _id: routeEmployeeId };

      return {
        ...prev,
        isModal: true,
        isEditModalData: {
          ...base,
          designation: keepPopulated(current?.designation, seeded?.designation) || base.designation,
          department: keepPopulated(current?.department, seeded?.department) || base.department,
          hrxRole: keepPopulated(current?.hrxRole, seeded?.hrxRole) || base.hrxRole,
          reportingManager:
            keepPopulatedList(current?.reportingManager, seeded?.reportingManager) ||
            base.reportingManager,
          reportingTeamLead:
            keepPopulatedList(current?.reportingTeamLead, seeded?.reportingTeamLead) ||
            base.reportingTeamLead
        },
        reportingManagerSelect: currentIsStub
          ? seeded?.reportingManager?._id || ''
          : prev.reportingManagerSelect
      };
    });
    window.scrollTo(0, 0);
  }, [routeEmployeeId, location.state?.employee?._id]);

  useEffect(() => {
    if (!routeEmployeeId) return;
    if (!EMPLOYEE_FORM_TABS.includes(tabFromQuery)) {
      setSearchParams({ tab: 'personal' }, { replace: true });
    }
  }, [routeEmployeeId, tabFromQuery, setSearchParams]);

  useEffect(() => {
    if (!showEmployeeForm) return;
    employeeDropDownQuery();
    teamLeadDropDownQuery();
    if (isAuOffice) adminDropDownQuery();
  }, [
    showEmployeeForm,
    isAuOffice,
    employeeDropDownQuery,
    teamLeadDropDownQuery,
    adminDropDownQuery
  ]);

  /*  const handleChangePage = (page) => {
    setState({ ...state, currentPage: page });
  }; */

  /* const handleChangeRowsPerPage = (newRowsPerPage) => {
    setState({ ...state, rowsPerPage: newRowsPerPage, currentPage: 1 });
  }; */

  /* const debouncedOnSearchData = _debounce((data) => {
    setState({ ...state, search: data });
  }, 500); */

  const workExperience = {
    companyName: '',
    jobTitle: '',
    fromDate: null,
    toDate: null
  };

  const educationDetails = {
    instituteName: '',
    degree: '',
    specialization: '',
    dateofCompletion: null
  };

  useEffect(() => {
    if (valuesData?.workExperience?.length < 1) {
      setValue('workExperience', [workExperience]);
    }
    if (valuesData?.educationDetails?.length < 1) {
      setValue('educationDetails', [educationDetails]);
    }
  }, [valuesData]);

  useEffect(() => {
    const lastYear = 1960;
    const currentYear = Number(moment().format('YYYY')) + 10;
    const yearData = [];
    for (let i = lastYear; i < currentYear; i++) {
      yearData.push({ value: i, label: i });
    }
    // setState({ ...state, yearsOption: [...yearData], dropdownDataStore: dropdownData?.data || [] });
    setState((prev) => ({ ...prev, yearsOption: [...yearData] }));
  }, []);

  const handleMenuScrollToBottom = async () => {
    if (dropdownData?.isNext) {
      setState((prevState) => ({
        ...prevState,
        currentPageDropdown: prevState.currentPageDropdown + 1
      }));
      employeeDropDownQuery();
    }
  };

  const handleMenuScrollToBottomTeamLead = async () => {
    if (teamLead?.isNext) {
      setState((prevState) => ({
        ...prevState,
        currentPageDropdown: prevState.currentPageDropdown + 1
      }));
      teamLeadDropDownQuery();
    }
  };

  const handleMenuScrollToBottomDesignation = () => {
    if (!state.designationDropdownIsNext || designationDropdownFetching) return;
    setState((prev) => ({
      ...prev,
      designationDropdownPage: prev.designationDropdownPage + 1
    }));
  };

  const handleMenuScrollToBottomDepartment = () => {
    if (!state.departmentDropdownIsNext || departmentDropdownFetching) return;
    setState((prev) => ({
      ...prev,
      departmentDropdownPage: prev.departmentDropdownPage + 1
    }));
  };

  const resetDesignationDropdown = () => {
    debouncedDesignationSearch.cancel();
    setState((prev) => ({
      ...prev,
      designationDropdownSearch: '',
      designationDropdownPage: 1
    }));
  };

  const resetDepartmentDropdown = () => {
    debouncedDepartmentSearch.cancel();
    setState((prev) => ({
      ...prev,
      departmentDropdownSearch: '',
      departmentDropdownPage: 1
    }));
  };

  const openDesignationDropdown = () => {
    setState((prev) => ({
      ...prev,
      designationDropdownSearch: '',
      designationDropdownPage: 1
    }));
    if (!state.designationDropdownStore.length) {
      refetchDesignationDropdown();
    }
  };

  const openDepartmentDropdown = () => {
    setState((prev) => ({
      ...prev,
      departmentDropdownSearch: '',
      departmentDropdownPage: 1
    }));
    if (!state.departmentDropdownStore.length) {
      refetchDepartmentDropdown();
    }
  };

  const handleDesignationInputChange = (text, meta) => {
    if (meta.action !== 'input-change') return;
    const term = String(text || '').trim();

    if (!term) {
      debouncedDesignationSearch.cancel();
      setState((prev) => ({
        ...prev,
        designationDropdownSearch: '',
        designationDropdownPage: 1
      }));
      return;
    }

    const hasLocalMatch = state.designationDropdownStore.some((item) =>
      String(item?.name || '')
        .toLowerCase()
        .includes(term.toLowerCase())
    );

    if (hasLocalMatch) {
      debouncedDesignationSearch.cancel();
      setState((prev) => ({
        ...prev,
        designationDropdownSearch: '',
        designationDropdownPage: 1
      }));
      return;
    }

    debouncedDesignationSearch(term);
  };

  const handleDepartmentInputChange = (text, meta) => {
    if (meta.action !== 'input-change') return;
    const term = String(text || '').trim();

    if (!term) {
      debouncedDepartmentSearch.cancel();
      setState((prev) => ({
        ...prev,
        departmentDropdownSearch: '',
        departmentDropdownPage: 1
      }));
      return;
    }

    const hasLocalMatch = state.departmentDropdownStore.some((item) =>
      String(item?.name || '')
        .toLowerCase()
        .includes(term.toLowerCase())
    );

    if (hasLocalMatch) {
      debouncedDepartmentSearch.cancel();
      setState((prev) => ({
        ...prev,
        departmentDropdownSearch: '',
        departmentDropdownPage: 1
      }));
      return;
    }

    debouncedDepartmentSearch(term);
  };

  useEffect(() => {
    if (!showEmployeeForm || !employeeDetail?._id) return;
    if (employeeDetail._id !== state.isEditModalData?._id) return;

    setState((prev) => {
      const current = prev.isEditModalData;
      const alreadyMerged =
        current?._detailId === employeeDetail._id &&
        current?._detailUpdatedAt === employeeDetail.updatedAt;

      const localPicture = current?.profilePicture;
      const keepLocalPicture = typeof localPicture === 'string' && localPicture.startsWith('blob:');
      const next = alreadyMerged
        ? current
        : {
            ...employeeDetail,
            _detailId: employeeDetail._id,
            _detailUpdatedAt: employeeDetail.updatedAt,
            profilePicture: keepLocalPicture ? localPicture : employeeDetail.profilePicture
          };

      const designation =
        pickNamedRecord(
          current?.designation,
          listEmployee?.designation,
          next.designation,
          designationById
        ) || next.designation;
      const department =
        pickNamedRecord(
          current?.department,
          listEmployee?.department,
          next.department,
          departmentById
        ) || next.department;
      const hrxRole =
        pickNamedRecord(current?.hrxRole, listEmployee?.hrxRole, next.hrxRole) || next.hrxRole;
      const reportingManager =
        keepPopulatedList(
          current?.reportingManager,
          keepPopulatedList(listEmployee?.reportingManager, next.reportingManager)
        ) || next.reportingManager;
      const reportingTeamLead =
        pickNamedRecord(
          current?.reportingTeamLead,
          listEmployee?.reportingTeamLead,
          next.reportingTeamLead,
          teamLeadById
        ) || next.reportingTeamLead;

      if (
        alreadyMerged &&
        designation === current.designation &&
        department === current.department &&
        hrxRole === current.hrxRole &&
        reportingManager === current.reportingManager &&
        reportingTeamLead === current.reportingTeamLead
      ) {
        return prev;
      }

      return {
        ...prev,
        isEditModalData: {
          ...next,
          designation,
          department,
          hrxRole,
          reportingManager,
          reportingTeamLead
        }
      };
    });
  }, [
    employeeDetail,
    listEmployee,
    designationById,
    departmentById,
    teamLeadById,
    showEmployeeForm,
    state.isEditModalData?._id
  ]);

  useEffect(() => {
    setState((prev) => {
      const current = prev.isEditModalData;
      if (!current?._id) return prev;

      const designation = pickNamedRecord(
        current.designation,
        listEmployee?.designation,
        findNamedRecord(prev.designationDropdownStore, current.designation),
        findNamedRecord(designationCatalog, current.designation),
        designationById
      );
      const department = pickNamedRecord(
        current.department,
        listEmployee?.department,
        findNamedRecord(prev.departmentDropdownStore, current.department),
        findNamedRecord(departmentCatalog, current.department),
        departmentById
      );
      const reportingManager = asUserRecords(
        current.reportingManager || listEmployee?.reportingManager
      ).map(
        (item) =>
          pickNamedRecord(
            item,
            findNamedRecord(asUserRecords(listEmployee?.reportingManager), item),
            findNamedRecord(mergeEmployeesById(dropdownData?.data, adminDropdown?.data), item),
            namedUsersById[String(toRecordId(item))]
          ) || item
      );
      const reportingTeamLead = pickNamedRecord(
        current.reportingTeamLead,
        listEmployee?.reportingTeamLead,
        findNamedRecord(
          mergeEmployeesById(teamLead?.data, adminDropdown?.data),
          current.reportingTeamLead
        ),
        teamLeadById
      );

      const designationChanged =
        hasDisplayName(designation) && !hasDisplayName(current.designation);
      const departmentChanged = hasDisplayName(department) && !hasDisplayName(current.department);
      const managerChanged =
        reportingManager.some(hasDisplayName) &&
        !asUserRecords(current.reportingManager).some(hasDisplayName);
      const teamLeadChanged =
        hasDisplayName(reportingTeamLead) && !hasDisplayName(current.reportingTeamLead);

      if (!designationChanged && !departmentChanged && !managerChanged && !teamLeadChanged) {
        return prev;
      }

      return {
        ...prev,
        isEditModalData: {
          ...current,
          ...(designationChanged ? { designation } : {}),
          ...(departmentChanged ? { department } : {}),
          ...(managerChanged ? { reportingManager } : {}),
          ...(teamLeadChanged ? { reportingTeamLead } : {})
        }
      };
    });
  }, [
    designationById,
    departmentById,
    teamLeadById,
    designationCatalog,
    departmentCatalog,
    namedUsersById,
    listEmployee,
    dropdownData?.data,
    teamLead?.data,
    adminDropdown?.data,
    state.designationDropdownStore,
    state.departmentDropdownStore,
    state.isEditModalData?._id,
    state.isEditModalData?.designation,
    state.isEditModalData?.department,
    state.isEditModalData?.reportingManager,
    state.isEditModalData?.reportingTeamLead
  ]);

  const isExistingEmployee = Boolean(routeEmployeeId || state.isEditModalData?._id);
  const detailHydrated = String(state.isEditModalData?._detailId || '') === String(routeEmployeeId);
  const formReady = formReadyId === String(routeEmployeeId);
  const isEmployeeFormLoading =
    Boolean(routeEmployeeId) &&
    !isEmployeeDetailError &&
    !formReady &&
    (isEmployeeDetailUninitialized ||
      isEmployeeDetailLoading ||
      isEmployeeDetailFetching ||
      Boolean(employeeDetail) ||
      detailHydrated);
  const experienceRows = getExperienceDisplayRows(state.isEditModalData);
  const educationRows = getEducationDisplayRows(state.isEditModalData);
  const isSavingDisabled =
    state.loading || isEmployeeFormLoading || (isExistingEmployee && isEmployeeDetailFetching);

  if (!routeEmployeeId) {
    return <Navigate to={EMPLOYEE_LIST_PATH} replace />;
  }

  if (isEmployeeFormLoading) {
    return <EmployeeFormSkeleton tab={formTab} onBack={() => closeEmployeeForm()} />;
  }

  return (
    <div className="employee-form container-xxl">
      <form key={routeEmployeeId} onSubmit={handleSubmit(onSubmit)}>
        <div className="employee-form__card">
          <div className="employee-form__cover">
            <div className="employee-form__cover-media">
              <img className="employee-form__cover-img" src={MITBanner} alt="" />
              <span className="employee-form__cover-shade" aria-hidden />
            </div>
            <button
              type="button"
              className="employee-form__back"
              aria-label="Back"
              onClick={() => closeEmployeeForm()}
            >
              <i className="icofont-rounded-left" aria-hidden />
            </button>
            <div className="employee-form__profile">
              <label className="employee-form__avatar-ring" htmlFor="employee-profile-pic">
                <img
                  className="employee-form__avatar"
                  src={
                    state?.isEditModalData?.profilePicture
                      ? state?.isEditModalData?.profilePicture
                      : withoutProfilePicture(state?.isEditModalData)
                  }
                  alt="Employee"
                />
                <span
                  className={`employee-form__avatar-overlay${profilePicUploading ? ' is-uploading' : ''}`}
                >
                  {profilePicUploading ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden />
                  ) : (
                    <>
                      <i className="icofont-camera" aria-hidden />
                      <span>Upload photo</span>
                    </>
                  )}
                </span>
                <input
                  id="employee-profile-pic"
                  ref={profilePicInputRef}
                  type="file"
                  accept="image/*"
                  className="employee-form__avatar-input"
                  disabled={profilePicUploading}
                  onChange={handleProfilePicChange}
                />
              </label>
              <div className="employee-form__identity">
                <div className="employee-form__title-row">
                  <h2 className="employee-form__title">
                    {state.isEditModalData?.name ||
                      valuesData?.name ||
                      (state.isEditModalData?._id
                        ? LB_EDIT_EMPLOYEE_HEADER
                        : LB_ADD_EMPLOYEE_HEADER)}
                  </h2>
                  {state.isEditModalData?.hrxRole?.roleName ? (
                    <span className="employee-form__chip employee-form__chip--role">
                      {state.isEditModalData.hrxRole.roleName}
                    </span>
                  ) : null}
                </div>
                <div className="employee-form__meta-row">
                  <p className="employee-form__meta">
                    <i className="icofont-email" aria-hidden />
                    {state.isEditModalData?.email ||
                      valuesData?.email ||
                      'Complete the employee profile'}
                  </p>
                  {state.isEditModalData?.designation?.name ? (
                    <span className="employee-form__meta-item">
                      {state.isEditModalData.designation.name}
                    </span>
                  ) : null}
                  {state.isEditModalData?.zohoEmployeeId || valuesData?.zohoEmployeeId ? (
                    <span className="employee-form__meta-item">
                      ID {state.isEditModalData?.zohoEmployeeId || valuesData?.zohoEmployeeId}
                    </span>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <nav className="employee-form__tabs" aria-label="Employee sections">
            <div className="employee-form__tabs-list">
              <button
                type="button"
                className={`employee-form__tab${formTab === 'personal' ? ' is-active' : ''}`}
                onClick={() => setFormTab('personal')}
              >
                <i className="icofont-user" aria-hidden />
                {LB_PERSONAL_INFORMATION}
              </button>
              <button
                type="button"
                className={`employee-form__tab${formTab === 'work' ? ' is-active' : ''}`}
                onClick={() => setFormTab('work')}
              >
                <i className="icofont-briefcase" aria-hidden />
                {LB_WORK}
              </button>
              <button
                type="button"
                className={`employee-form__tab${formTab === 'experience' ? ' is-active' : ''}`}
                onClick={() => setFormTab('experience')}
              >
                <i className="icofont-architecture-alt" aria-hidden />
                {LB_WORK_EXPERIENCE}
              </button>
              <button
                type="button"
                className={`employee-form__tab${formTab === 'education' ? ' is-active' : ''}`}
                onClick={() => setFormTab('education')}
              >
                <i className="icofont-education" aria-hidden />
                {LB_EDUCATION_DETAIL}
              </button>
            </div>
            <div className="employee-form__switches">
              <label className="employee-form__wfh" htmlFor="active-toggle">
                <div>
                  <span className="employee-form__wfh-label">Employee status</span>
                  <span className="employee-form__wfh-hint">
                    {valuesData?.isActive !== false ? 'Active' : 'Inactive'}
                  </span>
                </div>
                <Controller
                  name="isActive"
                  control={control}
                  defaultValue={true}
                  render={({ field }) => (
                    <div className="form-check form-switch theme-switch d-flex align-items-center">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={field.value !== false}
                        id="active-toggle"
                        {...register('isActive')}
                        onChange={field.onChange}
                      />
                    </div>
                  )}
                />
              </label>
              <label className="employee-form__wfh" htmlFor="wfh-toggle">
                <div>
                  <span className="employee-form__wfh-label">Work from home</span>
                  <span className="employee-form__wfh-hint">
                    {valuesData?.allowWorkFromHome ? 'Allowed' : 'Office only'}
                  </span>
                </div>
                <Controller
                  name="allowWorkFromHome"
                  control={control}
                  defaultValue={false}
                  render={({ field }) => (
                    <div className="form-check form-switch theme-switch d-flex align-items-center">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={field.value}
                        id="wfh-toggle"
                        {...register('allowWorkFromHome')}
                        onChange={field.onChange}
                      />
                    </div>
                  )}
                />
              </label>
            </div>
          </nav>

          <div className="employee-form__main">
            <section className={`employee-form__section${formTab !== 'personal' ? ' d-none' : ''}`}>
              <div className="employee-form__group">
                <h3 className="employee-form__group-title">Basic details</h3>
                <div className="row g-3">
                  <div className="col-md-6 col-xl-4">
                    <div className="employee-form__field">
                      <label htmlFor="exampleFormControlInput877" className="employee-form__label">
                        {LB_FULL_NAME}
                      </label>
                      <input
                        type="text"
                        {...register('name')}
                        className="form-control"
                        id="exampleFormControlInput877"
                        placeholder={PH_FULL_NAME}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="employee-form__field">
                      <label htmlFor="exampleFormControlInput777" className="employee-form__label">
                        {LB_EMPLOYEE_ROLE}
                      </label>
                      <Select
                        classNamePrefix="employee-form-select"
                        options={roleOptions}
                        placeholder={PH_EMPLOYEE_ROLE}
                        value={
                          getSelectDefault(valuesData.hrxRoleData, roleOptions) ||
                          getSelectDefault(state.isEditModalData?.hrxRole, roleOptions)
                        }
                        onChange={(selectedOption) => {
                          setValue('hrxRoleData', selectedOption?.value, { shouldValidate: true });
                          patchEmployeeSelectField('hrxRole', selectedOption);
                          setState((prev) => ({
                            ...prev,
                            roleSelect: selectedOption?.value
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="employee-form__field">
                      <label htmlFor="employee-code-input" className="employee-form__label">
                        {LB_EMPLOYEE_CODE}
                      </label>
                      <input
                        type="text"
                        {...register('zohoEmployeeId')}
                        className="form-control"
                        id="employee-code-input"
                        placeholder={PH_EMPLOYEE_CODE}
                      />
                      <small className="text-danger">
                        {getErrorMessage('zohoEmployeeId', errors)}
                      </small>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="employee-form__field">
                      <label htmlFor="exampleFormControlInput1778" className="employee-form__label">
                        {LB_PERSONAL_EMAIL}
                      </label>
                      <input
                        type="text"
                        {...register('personalEmail')}
                        className="form-control"
                        id="exampleFormControlInput1778"
                        placeholder={LB_PERSONAL_EMAIL}
                      />
                      <small className="text-danger">
                        {getErrorMessage('personalEmail', errors)}
                      </small>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="employee-form__field">
                      <label htmlFor="exampleFormControlInput1778" className="employee-form__label">
                        Confirmation
                      </label>
                      <select className="form-control" {...register('isConfirmationDone')}>
                        <option value="">Please select</option>
                        {CONFIRMATION_SWITCH.map((val, i) => {
                          return (
                            <option key={i} value={val.value}>
                              {val.label}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="employee-form__field">
                      <label htmlFor="exampleFormControlInput777" className="employee-form__label">
                        {LB_MOBILE}
                      </label>
                      <input
                        type="text"
                        {...register('phone')}
                        className="form-control"
                        id="exampleFormControlInput777"
                        placeholder={PH_MOBILE}
                      />
                      <small className="text-danger">{getErrorMessage('phone', errors)}</small>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div
                      className={`employee-form__field${isExistingEmployee ? ' employee-form__field--locked' : ''}`}
                    >
                      <label htmlFor="employee-company-email" className="employee-form__label">
                        {LB_COM_EMAIL}
                        {isExistingEmployee ? <i className="icofont-lock" aria-hidden /> : null}
                      </label>
                      <input
                        type="text"
                        {...register('email')}
                        className="form-control"
                        id="employee-company-email"
                        placeholder={LB_COM_EMAIL}
                        disabled={isExistingEmployee}
                      />
                      <small className="text-danger">{getErrorMessage('email', errors)}</small>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="employee-form__field">
                      <label htmlFor="exampleFormControlInput777" className="employee-form__label">
                        {LB_EMERGENCY_MOBILE}
                      </label>
                      <input
                        type="text"
                        {...register('emergencyMobile')}
                        className="form-control"
                        id="exampleFormControlInput777"
                        placeholder={LB_EMERGENCY_MOBILE}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="employee-form__field">
                      <label htmlFor="employee-date-of-joining" className="employee-form__label">
                        {LB_DATE_OF_JOINING}
                      </label>
                      <input
                        type="date"
                        value={editDateFormate(valuesData.dateOfJoining)}
                        onChange={(e) => {
                          const date = convertTimeStamp(e.target.value);
                          setValue('dateOfJoining', date);
                        }}
                        className="form-control"
                        id="employee-date-of-joining"
                        placeholder={LB_DATE_OF_JOINING}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="employee-form__field">
                      <label htmlFor="exampleFormControlInput1778" className="employee-form__label">
                        {LB_DOB}
                      </label>
                      <input
                        type="date"
                        value={editDateFormate(valuesData.dateOfBirth)}
                        onChange={(e) => {
                          const date = convertTimeStamp(e.target.value);
                          setValue('dateOfBirth', date);
                        }}
                        className="form-control"
                        id="exampleFormControlInput1778"
                        placeholder={LB_DOB}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="employee-form__field">
                      <label htmlFor="exampleFormControlInput1778" className="employee-form__label">
                        {LB_SOURCE_HR}
                      </label>
                      <select className="form-control" {...register('sourceOfHire')}>
                        <option value="">{PH_SOURCE_HIRE}</option>
                        {SOURCE_OF_HIRE.map((val, i) => {
                          return (
                            <option key={i} value={val.value}>
                              {val.label}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="employee-form__field">
                      <label htmlFor="exampleFormControlInput1778" className="employee-form__label">
                        {LB_NATIONALITY}
                      </label>
                      <select className="form-control" {...register('nationality')}>
                        <option value="">{PH_NATIONALITY}</option>
                        {countryData.map((val, i) => {
                          return (
                            <option key={i} value={val.name}>
                              {val.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="employee-form__field">
                      <label className="employee-form__label">{LB_GENDER_LABEL}</label>
                      <div className="employee-form__radios">
                        {GENDER_OPTION.map((checkbox) => (
                          <label
                            key={checkbox.value}
                            className={`employee-form__radio${checkbox.value === valuesData.gender ? ' employee-form__radio--active' : ''}`}
                          >
                            <input
                              type="radio"
                              className="form-check-input"
                              value={checkbox.value}
                              checked={checkbox.value === valuesData.gender ? true : false}
                              onChange={(e) => {
                                setValue('gender', e.target.value);
                              }}
                            />
                            <span>{checkbox.label}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="employee-form__field">
                      <label className="employee-form__label">{LB_MARITAL_STATUS_LABEL}</label>
                      <div className="employee-form__radios">
                        {MARITAL_STATUS_OPTION.map((checkbox) => (
                          <label
                            key={checkbox.value}
                            className={`employee-form__radio${checkbox.value === valuesData.maritalStatus ? ' employee-form__radio--active' : ''}`}
                          >
                            <input
                              type="radio"
                              className="form-check-input"
                              value={checkbox.value}
                              checked={checkbox.value === valuesData.maritalStatus ? true : false}
                              onChange={(e) => {
                                setValue('maritalStatus', e.target.value);
                              }}
                            />
                            <span>{checkbox.label}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="employee-form__field">
                      <label htmlFor="exampleFormControlInput777" className="employee-form__label">
                        {LB_ADDRESS}
                      </label>
                      <textarea
                        {...register('location')}
                        className="form-control"
                        id="exampleFormControlInput777"
                        placeholder={LB_ADDRESS}
                        rows={2}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {formTab === 'work' ? (
              <section className="employee-form__section">
                <div className="employee-form__group">
                  <h3 className="employee-form__group-title">Work information</h3>
                  <div className="row g-3">
                    <div className="col-md-6 col-xl-4">
                      <div className="employee-form__field">
                        <label
                          htmlFor="exampleFormControlInput777"
                          className="employee-form__label"
                        >
                          {LB_DESIGNATION_LABEL}
                        </label>
                        <Select
                          key={`designation-${routeEmployeeId}`}
                          classNamePrefix="employee-form-select"
                          isSearchable
                          filterOption={designationUsesServerSearch ? () => true : undefined}
                          onMenuOpen={openDesignationDropdown}
                          options={designationOptions}
                          isLoading={
                            designationDropdownFetching ||
                            Boolean(selectedDesignationId && !designationSelectValue)
                          }
                          onInputChange={handleDesignationInputChange}
                          onChange={(selectedOption) => {
                            setValue('designation', selectedOption?.value, {
                              shouldValidate: true
                            });
                            patchEmployeeSelectField('designation', selectedOption);
                          }}
                          onMenuClose={resetDesignationDropdown}
                          onMenuScrollToBottom={handleMenuScrollToBottomDesignation}
                          placeholder="Select option..."
                          value={designationSelectValue}
                        />
                        <small className="text-danger">
                          {getErrorMessage('designation', errors)}
                        </small>
                      </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                      <div className="employee-form__field">
                        <label
                          htmlFor="exampleFormControlInput777"
                          className="employee-form__label"
                        >
                          {LB_DEPARTMENT_LABEL}
                        </label>
                        <Select
                          key={`department-${routeEmployeeId}`}
                          classNamePrefix="employee-form-select"
                          isSearchable
                          filterOption={departmentUsesServerSearch ? () => true : undefined}
                          onMenuOpen={openDepartmentDropdown}
                          options={departmentOptions}
                          isLoading={
                            departmentDropdownFetching ||
                            Boolean(selectedDepartmentId && !departmentSelectValue)
                          }
                          onInputChange={handleDepartmentInputChange}
                          onMenuScrollToBottom={handleMenuScrollToBottomDepartment}
                          onMenuClose={resetDepartmentDropdown}
                          placeholder="Select option..."
                          value={departmentSelectValue}
                          onChange={(selectedOption) => {
                            setValue('department', selectedOption?.value, { shouldValidate: true });
                            patchEmployeeSelectField('department', selectedOption);
                            setState((prev) => ({
                              ...prev,
                              departmentSelect: selectedOption?.value
                            }));
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                      <div className="employee-form__field">
                        <label
                          htmlFor="exampleFormControlInput777"
                          className="employee-form__label"
                        >
                          {LB_REPORTING_MANAGER}
                        </label>
                        <Select
                          key={`reporting-manager-${routeEmployeeId}`}
                          classNamePrefix="employee-form-select"
                          isMulti
                          onMenuOpen={() => {
                            employeeDropDownQuery();
                            if (isAuOffice) adminDropDownQuery();
                          }}
                          options={projectManagerOptions}
                          isLoading={
                            dropdownDataIsFetching ||
                            dropdownDataLoading ||
                            (asUserRecords(
                              state.isEditModalData?.reportingManager ||
                                listEmployee?.reportingManager ||
                                employeeDetail?.reportingManager
                            ).length > 0 &&
                              !reportingManagerSelectValue.length)
                          }
                          onMenuScrollToBottom={handleMenuScrollToBottom}
                          placeholder="Select option..."
                          onChange={(selectedOptions) => {
                            const values = selectedOptions
                              ? selectedOptions.map((opt) => opt.value)
                              : [];

                            patchEmployeeSelectField('reportingManager', selectedOptions || []);
                            setState((prev) => ({
                              ...prev,
                              reportingManager: values
                            }));

                            setValue('reportingManager', values, { shouldValidate: true });
                          }}
                          value={reportingManagerSelectValue}
                        />
                        <small className="text-danger">
                          {getErrorMessage('reportingManager', errors)}
                        </small>
                      </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                      <div className="employee-form__field">
                        <label
                          htmlFor="exampleFormControlInput777"
                          className="employee-form__label"
                        >
                          {LB_REPORTING_TL}
                        </label>
                        <Select
                          key={`reporting-tl-${routeEmployeeId}`}
                          classNamePrefix="employee-form-select"
                          onMenuOpen={() => {
                            teamLeadDropDownQuery();
                            if (isAuOffice) adminDropDownQuery();
                          }}
                          options={teamLeadOptions}
                          isLoading={
                            teamLeadLoading ||
                            teamLeadDataIsFetching ||
                            Boolean(selectedTeamLeadId && !reportingTeamLeadSelectValue)
                          }
                          onMenuScrollToBottom={handleMenuScrollToBottomTeamLead}
                          placeholder="Select option..."
                          onChange={(selectedOption) => {
                            setValue('reportingTeamLead', selectedOption?.value, {
                              shouldValidate: true
                            });
                            patchEmployeeSelectField('reportingTeamLead', selectedOption);
                            setState((prev) => ({
                              ...prev,
                              reportingTeamLead: selectedOption?.value
                            }));
                          }}
                          value={reportingTeamLeadSelectValue}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                      <div className="employee-form__field">
                        <label
                          htmlFor="exampleFormControlInput777"
                          className="employee-form__label"
                        >
                          {LB_EMPLOYEE_TYPE}
                        </label>
                        <SingleSelectBox
                          value={valuesData.employmentType}
                          handleSelectedData={(val) => {
                            setValue('employmentType', val);
                          }}
                          options={EMPLOYEE_TYPE_OPTION}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="employee-form__field">
                        <label
                          htmlFor="exampleFormControlInput777"
                          className="employee-form__label"
                        >
                          {LB_COMPANY_ADDRESS}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder={LB_COMPANY_ADDRESS}
                          {...register('companyAddress')}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            ) : null}

            <section
              className={`employee-form__section${formTab !== 'experience' ? ' d-none' : ''}`}
            >
              <div className="employee-form__group">
                <h3 className="employee-form__group-title">Work experience</h3>
                <div className="employee-form__table-wrap">
                  <table className="table employee-form__table align-middle">
                    <thead>
                      <tr>
                        <th scope="col">{LB_COMPANY_NAME}</th>
                        <th scope="col">{LB_JOB_TITLE}</th>
                        <th scope="col">{LB_FROM_DATE}</th>
                        <th scope="col">{LB_TO_DATE}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {experienceRows.length ? (
                        experienceRows.map((val, i) => (
                          <tr key={i}>
                            <td>
                              <span className="employee-form__cell">{val.company}</span>
                            </td>
                            <td>
                              <span className="employee-form__cell">{val.title}</span>
                            </td>
                            <td>
                              <span className="employee-form__cell">
                                {val.start ? moment(val.start).format('DD MMM YYYY') : '-'}
                              </span>
                            </td>
                            <td>
                              {val.end === 0 ? (
                                <span className="employee-form__badge">Current</span>
                              ) : (
                                <span className="employee-form__cell">
                                  {val.end ? moment(val.end).format('DD MMM YYYY') : '-'}
                                </span>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="employee-form__empty">
                            {isExistingEmployee && isEmployeeDetailFetching
                              ? 'Loading work experience...'
                              : 'No work experience added'}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </section>

            <section
              className={`employee-form__section${formTab !== 'education' ? ' d-none' : ''}`}
            >
              <div className="employee-form__group">
                <h3 className="employee-form__group-title">Education detail</h3>
                <div className="employee-form__table-wrap">
                  <table className="table employee-form__table align-middle">
                    <thead>
                      <tr>
                        <th scope="col">{LB_INSTITUTE_NAME}</th>
                        <th scope="col">{LB_DEGREE}</th>
                        <th scope="col">{LB_SPECIALIZATION}</th>
                        <th scope="col">{LB_DATE_COMPLETION}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {educationRows.length ? (
                        educationRows.map((val, i) => (
                          <tr key={i}>
                            <td>
                              <span className="employee-form__cell">{val.institute}</span>
                            </td>
                            <td>
                              <span className="employee-form__cell">{val.degree}</span>
                            </td>
                            <td>
                              <span className="employee-form__cell">{val.specialization}</span>
                            </td>
                            <td>
                              <span className="employee-form__cell">{val.year}</span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="employee-form__empty">
                            {isExistingEmployee && isEmployeeDetailFetching
                              ? 'Loading education details...'
                              : 'No education details added'}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </section>
          </div>

          <div className="employee-form__footer">
            <button
              type="button"
              className="employee-form__cancel"
              onClick={() => closeEmployeeForm()}
            >
              {BTN_CANCEL}
            </button>
            <button type="submit" disabled={isSavingDisabled} className="employee-form__save">
              {isSavingDisabled ? (
                <div className="spinner-border spinner-border-sm" role="status"></div>
              ) : (
                BTN_SAVE
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default EmployeeDetails;
